import { isValidPhoneNumber } from 'libphonenumber-js';
import { z } from 'zod';

import { BUSINESS_TYPES } from '~/lib/marketing/lead-capture/lead-prompt';

export const QuickLeadSchema = z.object({
  name: z.string().trim().min(1).max(200),
  /** E.164 from the shared phone input, e.g. +966551234567. */
  whatsapp: z.string().trim().max(30).refine((value) => isValidPhoneNumber(value)),
  businessType: z.enum(BUSINESS_TYPES),
  /** Shared with the browser pixel so Meta deduplicates the Lead event. */
  eventId: z.string().uuid().optional(),
  trigger: z.enum(['paid', 'content']).optional(),
  pagePath: z.string().max(200).regex(/^\/[\w\-/]*$/).optional(),
  /** Honeypot: real users never fill this hidden field. */
  website: z.literal('').optional(),
});

export type QuickLeadData = z.infer<typeof QuickLeadSchema>;
